import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import api from '../lib/api';

export default function LoginPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const { data } = await api.post('/auth/login', { username, password: password || undefined });
            sessionStorage.setItem('token', data.token);
            sessionStorage.setItem('user', JSON.stringify(data.user));

            if (data.user.mustChangePassword) {
                navigate('/change-password');
            } else {
                navigate('/');
            }
        } catch (err: any) {
            setError(err.response?.data?.error || '로그인에 실패했습니다');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F7F7F7] flex items-center justify-center">
            <div className="w-full max-w-sm">
                <div className="bg-white rounded-lg shadow-lg border border-[#E6E9ED] p-8">
                    <div className="flex items-center justify-center gap-2 mb-6">
                        <Building2 className="w-6 h-6 text-[#1ABB9C]" />
                        <h1 className="text-lg font-bold text-[#2A3F54]">KYS 단지관리</h1>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-xs font-medium text-[#73879C] mb-1">아이디</label>
                            <input
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="w-full px-3 py-2.5 text-sm border border-[#E6E9ED] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1ABB9C]/20 focus:border-[#1ABB9C]"
                                placeholder="아이디를 입력하세요"
                                autoFocus
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-[#73879C] mb-1">비밀번호</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full px-3 py-2.5 text-sm border border-[#E6E9ED] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1ABB9C]/20 focus:border-[#1ABB9C]"
                                placeholder="조회전용은 비밀번호 없이 로그인"
                            />
                        </div>

                        {error && (
                            <div className="text-xs text-red-500 bg-red-50 px-3 py-2 rounded">{error}</div>
                        )}

                        <button
                            type="submit"
                            disabled={loading || !username}
                            className="w-full py-2.5 text-sm font-medium bg-[#1ABB9C] text-white rounded-lg hover:bg-[#169F85] transition disabled:opacity-50"
                        >
                            {loading ? '로그인 중...' : '로그인'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
